/*global google */
<template lang="html">
  <div class="slds-grid ">
    <div class="slds-col slds-medium-size_4-of-12 slds-large-size_3-of-12" style="height:650px; background-color: white; padding: 2px;">

      <gnetCard v-bind:nospace="true">        
        <template v-slot:body>

          <div class="mybox">
            <div style="margin: 2px; display:inline" v-on:click="domyhome">
              <svg height="24" width="24"><path v-bind:d="myhome" v-bind:stroke="myhomecolor"/></svg>
            </div>
            <div style="margin: 2px; display:inline" v-on:click="domylocation">
              <svg height="24" width="24"><path v-bind:d="mylocation" v-bind:stroke="mylocationcolor"/></svg>
            </div>
            
            <div class="xmybox" style="margin: 2px; display:inline; font-size:11px;">
              {{$t('Clienti:')}} {{records.length}}
            </div>
            <div class="xmybox" style="margin: 2px; display:inline; font-size:11px;">
              {{$t('Lead:')}} {{leads.length}}
            </div>
          </div>

          <div class="slds-grid">
            <gnetMenu class="slds-col mybox txtcenter" v-bind:symbol="'change_record_type'" v-bind:entries="menutipi" v-on:click="cambiaTipo($event)"></gnetMenu>
            <gnetMenu class="slds-col mybox txtcenter" v-bind:symbol="'food_and_drink'" v-bind:entries="menucategorie" v-on:click="filtraCategoria($event)"></gnetMenu>
            <gnetMenu class="slds-col mybox txtcenter" v-bind:symbol="'fulfillment_order'" v-bind:entries="menuordini" v-on:click="cambiaCategoria($event)"></gnetMenu>
          </div>

          <div class="mybox" v-if="nomescalacolori!='Categorie'">
            <div>{{nomescalacolori}}</div>
            <div class="slds-grid " style="font-size: 10px;">
              <div class="slds-col" v-for="colore in scalacolori" v-bind:key="colore.color" style="text-align:center; border: 1px solid lightgrey; padding-top: 2px;">
                <div class="tooltip" style="min-width:16px; border: 1px solid grey" v-bind:style="{ 'background-color': colore.color,'color':colore.color }">
                  x
                  <span class="tooltiptext" style="font-size: 14px;">{{colore.label}}</span>
                </div>
                <div>
                  {{colore.label}}
                </div>
              </div>
            </div>
          </div>

        </template>
      </gnetCard>

      <gnetAccordion v-bind:entries="sezioni" style="background-color:white; z-index:1">

        <template v-slot:places>
          <div>
            <div class="slds-form-element badgemargin">
              <span v-on:click="cercaRicerca(index)" class="slds-badge badgespace" v-for="(ricerca,index) in ricerche" v-bind:key="ricerca">{{ricerca}}
                <span v-on:click="eliminaRicerca(index)" class="slds-badge__icon slds-badge__icon_right">
                  <span class="slds-icon_container slds-icon-utility-close slds-current-color" v-bind:title="ricerca">
                    <svg class="slds-icon slds-icon_xx-small" aria-hidden="true">
                      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
                    </svg>
                  </span>
                </span>
              </span>
            </div>

            <div class="slds-form-element">
              <label v-if="false" class="slds-form-element__label" for="text-input-id-1">Ricerca</label>
              <div class="slds-form-element__control">
                <input v-model="placequery" type="text" id="text-input-id-1" placeholder="Ricerca..." required="" class="slds-input nospace" style="width:75%"/>
                
                <button v-on:click="placesearch" class="slds-button slds-button_icon slds-button_icon-brand marg_btn" style="float: right" title="Search">
                  <svg class="slds-button__icon" aria-hidden="true">
                    <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#search"></use>
                  </svg>
                  <span class="slds-assistive-text">{{$t('Cerca')}}</span>
                </button> 
                <button v-on:click="clearsearch" class="slds-button slds-button_icon slds-button_icon-brand marg_btn" style="float: right" title="close">
                  <svg class="slds-button__icon" aria-hidden="true">
                    <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
                  </svg>
                  <span class="slds-assistive-text">{{$t('close')}}</span>
                </button> 
              </div>
            </div>

            <div class="slds-clearfix" style="margin-top:7px;margin-bottom:4px;">
              <span class="slds-badge slds-badge_lightest slds-float_left">Importa:<em>{{selezionati}}</em> Ignora:<em>{{ignorati}}</em> Precedenti:<em>{{vecchi}}</em></span>
              <button v-bind:disabled="!placequerydone || (selezionati<1 && ignorati<1)" v-on:click="generateLeads" class="slds-button slds-button_brand slds-float_right w100">
                {{ $t("Importa") }}
              </button>
            </div>

            <ul class="slds-scrollable_y" style="height:300px;">
              <li v-for="r in placequeryresult" v-bind:key="r.place_id" style="borxder-bottom: 1px solid lightgrey; background-color: #fbfbfb">
                <div class="mybox" style="margin:2px" v-if="!mapplaces.has(r.place_id)">
                  <img v-bind:src="r.icon" style="width: 12px; margin: 4px; float:right;" />
                  <p v-on:click="openInfoWindow(r.place_id)" class="" style="border-bottom: 1px solid lightgrey;" v-bind:style="{'text-decoration-line': (r.salva?'':'line-through')}">{{r.name}} </p>
                  <p class="small" style="border-bottom: 1px solid lightgrey;" v-bind:style="{'text-decoration-line': (r.salva?'':'line-through')}">{{r.formatted_address}} </p>
                  <div class="slds-grid" >
                    <div class="slds-col slds-size_7-of-12">
                      <p class="small">{{r.business_status}}</p>
                      <p class="small">Livello {{r.price_level}} - Rating {{r.rating}} (Km:<span v-if="center">{{ distance(center.lat(), center.lng(), r.lat, r.lng).toFixed(2) }})</span>
                      </p>
                      <p class="small"><a v-bind:href="'https://www.google.com/maps/place/?q=place_id:'+r.place_id" target="_blank">{{ $t("Google Maps") }}</a></p>
                      <p class="small" v-if="r.disabled">Coincide con cliente esistente</p>


                      <button v-on:click.prevent="r.salva=!r.salva" v-bind:class="{'slds-is-selected':!r.salva}" class="slds-button slds-button_icon slds-button_icon-border-filled" aria-pressed="true" title="hide">
                        <svg class="slds-button__icon" aria-hidden="true">
                          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#hide"></use>
                        </svg>
                        <span class="slds-assistive-text">hide</span>
                      </button>
                    </div>
                    <div class="slds-col">
                      <span class="small" v-for="term in r.types" v-bind:key="term">
                        <a>{{ term }} &nbsp;</a>
                      </span>
                    </div>
                  </div>
                </div>  
              </li>
            </ul>

            <div v-if="placeNextPage">
              <button>Altri risultati</button>
            </div>
          </div>
        </template>

        <template v-slot:info>
          <div v-if="target" style="padding: 2px;">
            <a v-if="selected.tipoAccount__c == 'Lead'" v-bind:href="'/#/lead/' + selected.Id">
              <svg height="24" width="24"><path v-bind:d="svgfolder" /></svg>{{ $t("Scheda Lead") }}
            </a>
            <a v-if="selected.tipoAccount__c == 'Customer'" v-bind:href="'/#/custoner/' + selected.Id">
              <svg height="24" width="24"><path v-bind:d="svgfolder" /></svg>{{ $t("Scheda Cliente") }}
            </a>
            <p class="small">{{ targetName }}
              <span v-if="selected.record && selected.record.Places_id__c">(PlacesId)</span>
            </p>
            <p class="small">{{ targetAddress }}</p>

            <a v-if="selected.record && selected.record.Places_id__c" v-bind:href="'https://www.google.com/maps/place/?q=place_id:'+selected.record.Places_id__c" target="_blank">
              <svg height="24" width="24"><path v-bind:d="svgmap" /></svg>
              {{ $t("Google Maps + Places") }}
            </a>

            <a v-if="!selected.record || !selected.record.Places_id__c" v-bind:href="mapUrl + target" target="_blank">
              <svg height="24" width="24"><path v-bind:d="svgmap" /></svg>
              {{ $t("Google Maps") }}
            </a>
            <hr style="margin: 4px;" />

            <div v-if="showPlaces">
              <p class="small">{{ $t("Risultato ricerca:") }} {{ statusPlaces }}</p>
              <p class="small">
                {{ $t("Corrispondenze trovate:") }} {{ places.length }}
              </p>
              <div v-for="place in places" v-bind:key="place.name" v-bind:id="place.place_id">
                <div class="small">
                  <img v-if="place.icon" v-bind:src="place.icon" style="width: 16px; margin-right: 4px;"/>{{ place.name }}&nbsp;
                </div>
                <div class="small">{{ place.formatted_address }}</div>
                <div class="small">
                  {{ $t("Valutazione:") }} {{ place.rating }}
                  {{ $t("Recensioni:") }} {{ place.user_ratings_total }}
                </div>
                <div v-for="photo in place.photos" v-bind:key="photo.id">
                  <span v-if="false" v-html="photo.html_attributions"></span>
                  <img v-bind:src="photo.getUrl()" />
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-slot:markers>
          <div>
          <table class="slds-table slds-table_bordered slds-table_col-bordered" style="font-size:10px;">
            <thead>
              <tr>
                <th>Codice</th>
                <th>Ragione Sociale</th>
                <th>{{nomescalacolori}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="m in markers" v-bind:key="m.Id">
                <td style="text-align:right;">
                  {{m.codice}}
                </td>
                <td>
                  <a v-if="m.Id && m.codice" v-bind:href="'/#/customer/'+m.Id">{{m.record.Name}}</a>
                  <a v-if="m.Id" v-bind:href="'/#/lead/'+m.Id">{{m.record.Name}}</a>
                  <span v-if="!m.Id">{{m.record.Name}}</span>
                </td>
                <td style="text-align:right;">
                  {{m.attributo}}
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </template>

      </gnetAccordion>

    </div>

    <div class="slds-col  slds-medium-size_8-of-12 slds-large-size_9-of-12" style="height:650px;">
      <div id="themap"></div>
    </div>



  </div>
</template>

<script>
import apiclient from '@/apiclient.js'
import { mdiCrosshairsGps } from '@mdi/js';
import { mdiHome } from '@mdi/js';
import { mdiFolder } from '@mdi/js';
import { mdiGoogleMaps } from '@mdi/js';
import {Marker} from '@googlemaps/adv-markers-utils';

import gnetCard from '../components/card.vue'
import gnetMenu from '../components/dropmenu.vue'
import gnetAccordion from '../components/accordion.vue'

// import fakeplaces from '../trattorie.json'

export default {
  name: "gnetMap21",
  components: {
    gnetCard,
    gnetMenu,
    gnetAccordion
  },
  props: {
  },
  watch: {
    actualdealer: function() {
      this.redrawMarkers();
    },
  },
  computed: {
    actualdealer: function() {
      if (this.$store.state.multizona && (this.$store.getters.isAdmin || this.$store.getters.isAreaManager)) 
        return this.$store.getters.zona;
      else return "";
    },
    vecchi: function() {
      var i=0;
      this.placequeryresult.forEach(function(p) {
        if (this.mapplaces.has(p.place_id) ) i++;
      }, this);
      return i;
    },
    selezionati: function() {
      var i=0;
      this.placequeryresult.forEach(function(p) {
        if (p.salva && !this.mapplaces.has(p.place_id) ) i++;
      }, this);
      return i;
    },
    ignorati: function() {
      var i=0;
      this.placequeryresult.forEach(function(p) {
        if (!p.salva) i++;
      })
      return i;
    },
  },
  data() {
    return {
      ricerche: [ ],
      sezioni: [
        { id:'0', label:'Google Places', name:'places', open:false},
        { id:'1', label:'Markers', name:'markers', open:false},
        { id:'2', label:'Google info', name:'info', open:true},
      ],
      colori: [ // aggiornate icone e codice colore
        { nomeicona:'marrone', colore:' #8c5a2b' }, //0
        { nomeicona:'rosso', colore:' #f20000' },
        { nomeicona:'rosa', colore:' #e60085' }, //2
        { nomeicona:'arancio', colore:' #ff9900' },
        { nomeicona:'giallo', colore:' #fce957' }, //4
        { nomeicona:'verde', colore:' #4e9b17' },
        { nomeicona:'verdechiaro', colore:' #6bc71f' }, //6 in realta' e' verde chiaro // GE: cambiato nome verdechiaro
        { nomeicona:'azzurro', colore:' #1fbfff' },
        { nomeicona:'blue', colore:'#4562d7' }, //8
        { nomeicona:'viola', colore:'#9e00ce' }, //9
        { nomeicona:'grigio', colore:'#999999' }, //10
        { nomeicona:'nero', colore:'#000000' }, 
        { nomeicona:'bianco', colore:'#ffffff' }, 

/*
        { nomeicona:'ocra', colore:'#FF9900' },
        { nomeicona:'marrone', colore:'#7D2F00' },
        { nomeicona:'verde', colore:'#006B5F' },
        { nomeicona:'verdechiaro', colore:'#62BAAC' },
*/
        // colore nullo #b6b0a8 
      ],
      nomescalacolori:'',
      scalacolori: [],
      menutipi: [
        { name:'0', label:'Lead',isAccount: true, filters: [ "tipoAccount__c='Lead'" ] },
        { name:'1', label:'Clienti', isAccount: true, filters: [ "tipoAccount__c='Customer'", "SP_attivo__c = FALSE" ] },
        { name:'5', label:'Clienti Attivi', isAccount: true, filters: [ "tipoAccount__c='Customer'", "SP_attivo__c = TRUE" ] },
        { name:'2', label:'PV Seven (S)', isLead: true, filters: [ "LeadSource = 'Punto Vendita Seven'" ] },
        { name:'3', label:'PV TintaUnita (T)', isLead: true, filters: [ "LeadSource = 'Punto Vendita TintaUnita'" ] },
        { name:'6', label:'PV Lisciani (L)', isLead: true, filters: [ "LeadSource = 'Punto Vendita Lisciani'" ] },
        { name:'4', label:'Cessati', isAccount: true, filters: [ "SP_Cessato__c = TRUE" ] },
      ],
      menuPinAttributes: new Map([
        [ '2', { numerocolore: 8, glyphText: 'S', glyphColor: 12 }],
        [ '3', { numerocolore: 9, glyphText: 'T', glyphColor: 12 }],
        [ '4', { numerocolore: 10, bordercolor: 12, glyphText: 'C', glyphColor: 12 }],
        [ '5', { numerocolore: 1, glyphText: 'A', glyphColor: 12 }],
        [ '6', { numerocolore: 7, glyphText: 'L', glyphColor: 12 }]
      ]),
      mapcategorie: {},
      menucategorie: [
        { checked:true, name:'0', label:'Cartoleria', icon:'choice', numerocolore: 1, color:'', nomeicona:''},
        { checked:true, name:'1', label:'Libreria', icon:'choice', numerocolore: 3, color:'', nomeicona:''},
        { checked:true, name:'2', label:'Abbigliamento', icon:'choice', numerocolore: 2, color:'', nomeicona:''},
        { checked:true, name:'3', label:'Altro', icon:'choice', numerocolore: 0, color:'', nomeicona:''},
      ],
      menuordini: [
        { checked:true, name:'0', label:'Categorie' }
      ],
      scalaordine: [
        {label:'>180gg', numerocolore: 0, color:'', nomeicona:'' },
        {label:'>90gg', numerocolore: 1, color:'', nomeicona:'' },
        {label:'>60gg', numerocolore: 3, color:'', nomeicona:'' },
        {label:'>30gg', numerocolore: 4, color:'', nomeicona:'' },
        {label:'>7gg', numerocolore: 6, color:'', nomeicona:'' },
        {label:'<7gg', numerocolore: 7, color:'', nomeicona:'' },
      ],
      scalafatturato: [
        {label:'<1k', numerocolore: 0, color:'', nomeicona:'' },
        {label:'<10k', numerocolore: 1, color:'', nomeicona:'' },
        {label:'<20k', numerocolore: 3, color:'', nomeicona:'' },
        {label:'<30k', numerocolore: 4, color:'', nomeicona:'' },
        {label:'<50k', numerocolore: 6, color:'', nomeicona:'' },
        {label:'>50k', numerocolore: 7, color:'', nomeicona:'' },
      ],
      scaladelta: [
        {label:'---', numerocolore: 0, color:'', nomeicona:'' },
        {label:'-30k', numerocolore: 1, color:'', nomeicona:'' },
        {label:'-10k', numerocolore: 3, color:'', nomeicona:'' },
        {label:'~=', numerocolore: 4, color:'', nomeicona:'' },
        {label:'+10k', numerocolore: 5, color:'', nomeicona:'' },
        {label:'+30k', numerocolore: 6, color:'', nomeicona:'' },
        {label:'+++', numerocolore: 7, color:'', nomeicona:'' },
      ],
      placequery: '',
      placequerydone: false,
      placeNextPage: undefined,
      placequeryresult: [],
      placespanel: false,
      svgmap: mdiGoogleMaps,
      svgfolder: mdiFolder,
      mylocationstatus: false,
      mylocation: mdiCrosshairsGps,
      myhome: mdiHome,
      mylocationcolor: "grey",
      myhomecolor: "grey",
      mylocationtimer: "",
      showPlaces: false,
      statusPlaces: "",
      target: "",
      targetName: "",
      targetAddress: "",
      mapUrl: "https://maps.google.com/maps?q=",
      places: [],
      placename: {},
      images: [],
      imagesurl: [],
      markers: [],
      mapplaces: {},
      maplatitudes: {},
      mapmarkers: {},
      mapids: {},
      records: [],
      leads: [],
      range: "450",
      heatmapmode: false,
      center: {},
      accounttype: [],
      heatmap: {},
      timer: "",
      lSelected: [],
      mSelected: {},
      selected: {},
    };
  },
  created: function() {
    console.log('map created');
    this.mapmarkers=new Map();
    this.mapids=new Map();
    this.mapplaces=new Map();
    this.maplatitudes=new Map();
    this.scalacolori=this.menucategorie;
    this.nomescalacolori='Categorie';
    /*
    this.placequeryresult=fakeplaces;
    this.placequeryresult.forEach(function(d) {
      d.geometry.location.lat=d.lat;
      d.geometry.location.lng=d.lng;
      this.$set(d,'salva',true);
    }, this);
    this.placequerydone=true;
    */
    this.menucategorie.forEach(this.colora);
    this.scalaordine.forEach(this.colora);
    this.scalafatturato.forEach(this.colora);
    this.scaladelta.forEach(this.colora);
    this.mapcategorie=new Map();
    this.menucategorie.forEach(function(c,i) {
      this.mapcategorie.set(c.label,i);
    }, this);
  },
  mounted: function() {
    var ricerche=localStorage.getItem('salespaddy-ricerche');
    if (ricerche) this.ricerche=JSON.parse(ricerche);

    console.log("map mounted");
    var self = this;

    if (this.$store.getters.position.lat == undefined) {
      console.log("position.lat non trovata");

      if (this.$store.getters.connection.userdata.mylocation) {
        var pos=this.$store.getters.connection.userdata.mylocation;
        console.log("posizione predefinita");
        console.log(pos);
        self.$store.commit("SET_POSITION", pos);

        self.firstInit();
      }
    } else {
      console.log("initMap");
      this.initMap();
      this.$store.dispatch("moveToMyPos");

      this.$store.getters.map.addListener("bounds_changed", this.changeBounds);
      this.redrawMarkers();
    }
    this.accounttype=this.$store.state.filtrotipi;
    this.accounttype.forEach(function(t,i) {
        this.menutipi[i].checked=t.checked;
    }, this)
    console.log(this.menutipi)
    this.cambiaCategoria(this.$store.state.filtrotipo, true);
    this.$store.state.filtrocategoria.forEach(function(c,i) {
      this.menucategorie[i].checked=c;
    }, this);
  },
  methods: {
    distance: function(lat1,lng1,lat2,lng2) {
      const R = 6371e3; // metres
      const phi1 = lat1 * Math.PI/180; // φ, λ in radians
      const phi2 = lat2 * Math.PI/180;
      const deltaphi = (lat2-lat1) * Math.PI/180;
      const deltalambda = (lng2-lng1) * Math.PI/180;

      const a = Math.sin(deltaphi/2) * Math.sin(deltaphi/2) +
                Math.cos(phi1) * Math.cos(phi2) *
                Math.sin(deltalambda/2) * Math.sin(deltalambda/2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

      const d = R * c; // in metres

      return d/1000; // in km
    },
    colora: function(v) {
      v.color=this.colori[v.numerocolore].colore;
      v.nomeicona=this.colori[v.numerocolore].nomeicona;
    },
    setMarkerPinAttributes(marker, attributes) {
      var myPin = new google.maps.marker.PinElement(attributes);
      marker.myPinElement = myPin;     
      marker.content = myPin.element;
      return marker
    },
    eliminaRicerca: function(index) {
      if(confirm('Eliminare ricerca '+this.ricerche[index])) {
        this.ricerche.splice(index,1);
        localStorage.setItem('salespaddy-ricerche', JSON.stringify(this.ricerche));
      }
    },
    cercaRicerca: function(index) {
      this.placequery=this.ricerche[index];
      this.placesearch();
    },
    cambiaTipo: function(e) {
      this.menutipi[e].checked=!this.menutipi[e].checked;
      this.accounttype[e].checked=!this.accounttype[e].checked;
      this.$store.commit('SET_FILTROTIPI', this.accounttype);

      this.removeMarkersAll();
      this.redrawMarkers();
    },
    filtraCategoria: function(e) {
      this.menucategorie[e].checked=!this.menucategorie[e].checked;

      this.$store.commit('SET_FILTROCATEGORIE', e);

      this.removeMarkersAll();
      this.redrawMarkers();
    },
    cambiaCategoria: function(e, skip) {
      this.menuordini.forEach(function(m) { m.checked=false;});
      this.menuordini[e].checked=true;
      switch(e) {
        case 0:
          this.nomescalacolori='Categorie'
          this.scalacolori=this.menucategorie;
          break;
        case 1:
          this.nomescalacolori='Ultimo Ordine'
          this.scalacolori=this.scalaordine;
          break;
        case 2:
          this.nomescalacolori='Fatturato AC'
          this.scalacolori=this.scalafatturato;
          break;
        case 3:
          this.nomescalacolori='Differenza AC-AP'
          this.scalacolori=this.scaladelta;
          break;
      }

      if (!skip) {
        this.$store.commit('SET_FILTROTIPO', e);
        this.removeMarkersAll();
        this.redrawMarkers();
      }

    },
    clearsearch: function() {
      this.placequerydone = false;
      this.placequeryresult = [];
      this.placequery='';
      this.redrawMarkers();
    },
    checkbounds: function(bounds, lat, lng) {
      // eslint-disable-next-line no-undef
      var pos=new google.maps.LatLng(lat, lng);
      return bounds.contains(pos);
    },
    placesearch: function() {
      var self = this;
      var map = this.$store.getters.map;
      // var ll = map.getCenter();
      var bounds = map.getBounds();
      this.center=bounds.getCenter();

      console.log('placesearch in:');
      console.log(bounds);
      var request = {
        bounds: bounds,
        query: this.placequery,
      };

      this.placequerydone = false;
      self.placequeryresult = [];

      // eslint-disable-next-line no-undef
      var service = new google.maps.places.PlacesService(map);
      service.textSearch(request, function(results, status, pagination) {
        // eslint-disable-next-line no-undef
        if (status == google.maps.places.PlacesServiceStatus.OK) {
          
          self.placequerydone = true;
          results.forEach(function(r) {
            // console.log(JSON.stringify(r));
            // r.salva=true;
            r.lat=r.geometry.location.lat();
            r.lng=r.geometry.location.lng();
            r.salva=true;

            if (self.checkbounds(bounds, r.lat, r.lng)) {
              // shallow copy to avoid google warnings
              var o={
                business_status: r.business_status,
                price_level: r.price_level,
                rating: r.rating,
                lat: r.lat,
                lng: r.lng,
                formatted_address: r.formatted_address,
                icon: r.icon,
                place_id: r.place_id,
                name: r.name,
                types: r.types.slice(),
                distance: self.distance(self.center.lat(), self.center.lng(), r.lat, r.lng),
                salva: true,
                disabled: false
              }
              self.placequeryresult.push(o);
              console.log('check matching');
              var r2=self.matchLatLng(o.name, o.lat, o.lng);
              if (r2) {
                console.log('ignora '+o.name);
                console.log(o);
                o.salva=false;
                o.disabled=true;
              }              
            } else {
              console.log('ignora per out of bound:'+r.name);
            }
          }, this);

          self.placequeryresult.sort(function(a,b) {
            return a.distance-b.distance;
          })

          console.log('pagination:'+pagination.hasNextPage);
          if (pagination.hasNextPage) pagination.nextPage();
          self.redrawMarkers();
          
        }
      });
    },
    generateLeads: function() {
      if (this.ricerche.indexOf(this.placequery)<0) {
        this.ricerche.push(this.placequery);
        localStorage.setItem('salespaddy-ricerche', JSON.stringify(this.ricerche));
      }

      this.placequeryresult.forEach(function(r) {
        // if (r.salva) {
          var l=this.setLead(r, r.salva);
          console.log(l);
          apiclient
            .upsert(
              this.$store.getters.connection,
              "Account",
              "Places_id__c",
              r.place_id,
              l
            )
            .then(function(data) {
              console.log("lead created:" + data.length);
              console.log(data);
            })
            .catch(function(err) {
              console.log(err);
            });
        // }
      }, this);
      this.placequerydone = false;
    },
    setLead: function(p, status) {
      var l = {
        Name: p.name,
        Places_formatted_address__c: p.formatted_address,
        Places_lat__c: p.lat,
        Places_lng__c: p.lng,
        Places_icon__c: p.icon,
        // Places_photos: (p.photos?(p.photos.length>0?p.photos[0].html_attributions:null):null),
        // Places_place_id__c: p.place_id,
        Places_price_level__c: p.price_level,
        Places_rating__c: p.rating,
        Places_types__c: p.types ? p.types.join(";") : null,
        Places_user_ratings_total__c: p.user_ratings_total,
        Zona_1__c: this.$store.getters.zona,
        Fonte__c: "Google Places via SalesPaddy",
      };
      if (!status) l.Status='Non qualificato';
      var add = p.formatted_address.split(",");
      var add2 = add[2].trim().split(" ");
      l.BillingStreet = add[0] + ", " + add[1]; // parseFloat( add[1] );
      l.BillingCity = add2[1];
      l.BillingPostalCode = parseFloat(add2[0]);
      l.BillingState = add2[2];
      l.BillingCountry = add[3];

      return l;
    },
    addPlace: function(p) {
      // var self = this;
      var pos = {
        lat: p.lat,
        lng: p.lng
      };

      var marker = new Marker({
        position: pos,
        map: this.$store.getters.map,
        title: p.name,
      })

      marker = this.setMarkerPinAttributes(marker, { background: this.colori[4].colore })

      this.markers.push(marker);
    },
    firstInit: function() {
      this.initMap();
      this.$store.dispatch("moveToMyPos");

      this.$store.getters.map.addListener("bounds_changed", this.changeBounds);
      this.redrawMarkers();
    },
    domyhome: function() {
      this.myhomecolor = "grey";
      var pos = this.$store.getters.connection.userdata.mylocation;
      pos = {
        lat: this.$store.getters.connection.userdata.Account.ShippingLatitude,
        lng: this.$store.getters.connection.userdata.Account.ShippingLongitude,
      };
      console.log("posizione predefinita");
      console.log(pos);

      this.$store.commit("SET_POSITION", pos);
      this.$store.dispatch("moveToMyPos");

      if (this.mylocationstatus) {
        this.mylocationcolor = "grey";
        this.mylocationstatus = false;
        clearInterval(this.mylocationtimer);
      }
    },
    domylocation: function() {
      this.myhomecolor = "white";
      if (this.mylocationstatus) {
        this.mylocationcolor = "grey";
        this.mylocationstatus = false;
        clearInterval(this.mylocationtimer);
      } else {
        this.mylocationcolor = "red";
        this.mylocationstatus = true;

        var self = this;
        self.$store.dispatch("getPosition").then(function() {
          self.$store.dispatch("moveToMyPos");
        });
        this.mylocationtimer = setInterval(function() {
          self.$store.dispatch("getPosition").then(function() {
            self.$store.dispatch("moveToMyPos");
          });
        }, 5000);
      }
    },
    gotoCustomer: function(index) {
      this.$router.push({
        name: "ClientiRecord",
        params: {
          id: this.records[index]["Id"],
        },
      });
    },
    changeBounds: function() {
      var map = this.$store.getters.map;
      var ll = map.getCenter();
      this.center=ll;
      this.$store.commit("SET_POSITION", {
        lat: ll.lat(),
        lng: ll.lng(),
      });

      if (this.timer) clearTimeout(this.timer);

      var self = this;
      this.timer = setTimeout(function() {
        console.log("redraw map");
        self.timer = undefined;
        self.redrawMarkers();
      }, 200);
    },
    redrawMarkers: function() {
      console.log('redrawMarkers');
      var self = this;
      self.getAllRecords()
      .then(function() {
        console.log('fine getAllRecords');
        self.addMarkers();
        self.removeMarkers();
      }).catch(function(err) {
        console.error('getAllRecords err',err)
      })
    },
    removeMarkers: function() {
      for (var i=0; i<this.markers.length;) {
        var m=this.markers[i];        
        if (!this.mapids.has(m.Id)) {
          m.map = null
          this.markers.splice(i, 1);
          this.mapmarkers.delete(m.Id);
        } else {
          i++;
        }
      }
    },
    removeMarkersAll: function() {
      console.log('removeMarkersAll');
      this.markers.forEach(function(m) {
        m.map = null
      });
      this.markers.splice(0, this.markers.length);
      this.mapmarkers=new Map();
    },
    openInfoWindow: function(Id) {
      var r=this.mapmarkers.get(Id);      
      // eslint-disable-next-line no-undef
      var info=new google.maps.InfoWindow();
      info.setContent(r.record.Name);
      info.open(this.$store.getters.map,r);
    },
    openInfoWindow2: function(Id) {
      var r=this.mapmarkers.get(Id);    
      console.log('openInfoWindow2');  
      console.log(r);  
      // eslint-disable-next-line no-undef
      var info=new google.maps.InfoWindow();
      var q='';
      if (this.places.length>0) {
        if (r.targetName)
          q+='<div>'+r.targetName+'</div>';
        if (r.targetAddress)
          q+='<div class="small">'+r.targetAddress+'</div>';
      } else {
        if (r.record) {
          q='<div class="small">'+r.record.Name+'</div>';
        }
      }

      console.log('openInfoWindow2')
      console.log(r)
      info.setContent(q);
      info.open(this.$store.getters.map,r);
    },
    clickMarker: function(Id) {
      console.log('-> clickMarker', Id)
      var r=this.mapmarkers.get(Id);      
      this.selected=r;
      console.log('r', r)

      var lat = r.position ? r.position.lat : r.attributes_.position.lat
      var lng = r.position ? r.position.lng : r.attributes_.position.lng
        
      // eslint-disable-next-line no-undef
      var posobj=new google.maps.LatLng( lat, lng );

      this.target=r.record.Name+' '+r.targetAddress;
      this.targetName=r.record.Name;
      this.targetAddress=r.targetAddress;
      
      var fields=['formatted_address','geometry','icon','name','formatted_address','photos','place_id','formatted_address','plus_code','types','price_level','rating','user_ratings_total'];
      var request = {
        query: this.target,
        fields: fields,
        locationBias:{ radius: 100, center: posobj }
      };

      console.log('searching on google:', lat, lng);
      console.log(request);

      this.places = [];
      this.showPlaces = false;
      this.statusPlaces = "";

      // eslint-disable-next-line no-undef
      var service = new google.maps.places.PlacesService(this.$store.getters.map);
      var self=this;
      if (!r.record.Places_id__c) {
        service.findPlaceFromQuery(request, function(results, status) {
          self.showPlaces = true;
          self.statusPlaces = status;
          console.log(status);
          // eslint-disable-next-line no-undef
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            self.places = results;
            console.log(results);
          }
        });
      } else {
        console.log('getDetails')
        request = {
          placeId: r.record.Places_id__c,
          fields: fields,
        };
        console.log(request)
        service.getDetails(request, function(results, status) {
          self.showPlaces = true;
          self.statusPlaces = status;
          console.log(status);
          // eslint-disable-next-line no-undef
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            self.places = [results];
            console.log(results);
            self.$nextTick(function() {
              self.openInfoWindow2(r.record.Id);
            });
          }
        });
      }


    },
    addMarkersInt: function(d, pos, isAccount) {
      // console.log('addMarkersInt', d);

      if (d.disabled) return;
      if (!pos.lat || !pos.lng) return; 

      var self=this;

      var marker = new Marker({
        position: pos,
        map: this.$store.getters.map,
        title: d.targetName
      })

      var att = {}
      if(d.Key && this.menuPinAttributes.has(d.Key)) {
        var info = this.menuPinAttributes.get(d.Key)

        att.background = this.colori[info.numerocolore].colore,
        att.borderColor = info.bordercolor ? this.colori[info.bordercolor].colore : this.colori[info.numerocolore].colore,
        att.glyphColor = info.glyphColor ? this.colori[info.glyphColor].colore : this.colori[info.numerocolore].colore,
        att.glyphText = info.glyphText

      }

      if (!isAccount) att.background = this.colori[4].colore

      if (d.nomeicona) {
        att.background = this.colori.find( c => c.nomeicona == d.nomeicona).colore 
        att.borderColor = this.colori.find( c => c.nomeicona == d.nomeicona).colore 
      }

      marker = this.setMarkerPinAttributes(marker, att)

      marker.Id=d.Id;
      marker.codice=d.Codice_2019__c;
      marker.placeId=d.Places_id__c;
      if (d.place_id) marker.placeId=d.place_id;
      marker.isAccount=isAccount;
      marker.Categoria_Vendita__c=d.Categoria_Vendita__c;
      marker.record=d;
      marker.attributo=d.attributo;

      if(d.LeadSource) {
        marker.targetName = d.Name
        marker.title = d.Name
        marker.targetAddress = d.Street+' '+d.City
      } else {
        marker.targetName=d.targetName;
        marker.targetAddress=d.BillingStreet+' '+d.BillingCity;
      }

      marker.addListener('click', function() {
        self.clickMarker(marker.Id);
      });
      this.markers.push(marker);
      this.mapmarkers.set(d.Id, marker);
    },
    addMarkers: function() {
      console.log('addMarkers');

      var self = this;

      console.log('records:'+this.records.length);
      this.records.forEach(function(d, i) {
        if (!this.mapmarkers.has(d.Id)) {          
          var pos = {}
          if(d.BillingLatitude && d.BillingLongitude) {
            pos = {
              lat: d.BillingLatitude,
              lng: d.BillingLongitude
            }
          }
          if(d.Latitude && d.Longitude) {
            pos = {
              lat: d.Latitude,
              lng: d.Longitude
            }
          }
          self.addMarkersInt(d,pos,true);
        }
      }, this);

      console.log('leads:'+this.records.length);
      this.leads.forEach(function(d, i) {
        if (!this.mapmarkers.has(d.Id)) {
          var pos = {
            lat: d.BillingLatitude,
            lng: d.BillingLongitude
          };
          self.addMarkersInt(d,pos,false);
        }
      }, this);

      console.log('placequeryresult:'+this.records.length);
      this.placequeryresult.forEach(function(r,i) {
        if (!this.mapmarkers.has(r.place_id)) {
          r.targetName=r.name;
          r.Name=r.name;
          r.Id=r.place_id;
          r.isPlace=true;
          this.mapids.set(r.Id,r);
          var pos= { lat: r.lat, lng: r.lng};

          console.log('place:'+r.name);
          console.log(pos);
          this.addMarkersInt(r,pos,false);
        }
      }, this)

    },
    roundLat: function(l) {
      // lat in gradi 10-3 = 100metri
      return Math.round(l*500)/500;
    },
    roundLng: function(l) {
      // lat in gradi 10-3 = 100metri
      return Math.round(l*500)/500;
    },
    matchLatLng: function(name,lat,lng) {
      var rlat=this.roundLat(lat);
      var rlng=this.roundLng(lng);
        console.log('checking lat:'+rlat+' original:'+lat);
      if (this.maplatitudes.has(rlat)) { // match lat
        console.log('same lat:'+rlat+' original:'+lat);
        var arrl=this.maplatitudes.get(rlat);
        console.log('checking:'+arrl.length);
        var found=undefined;
        arrl.forEach(function(r) {
          if (rlng==this.roundLng(r.Longitude)) {
            console.log('match:');
            console.log(r.Name);
            console.log(r.Latitude);
            console.log(r.Longitude);
            console.log(name);
            console.log(lat);
            console.log(lng);
            found=r;
          }
        }, this);
      }
      return found;
    },
    addLat: function(l, o) {
      var lr=this.roundLat(l);
      if (!this.maplatitudes.has(lr)) this.maplatitudes.set(lr, []);
      var arrl=this.maplatitudes.get(lr);
      arrl.push(o);
    },
    calcolaColori: function(r) {
      // Categoria_Vendita__c, GG_Ultimo_Ordine__c,Data_Ultimo_Ordine__c, Fatturato_AC__c, Fatturato_AP__c, Fatturato_AP_YTD__c, Fatturato_delta_AC_AP_YTD__c, Frequenza_Fatture__c
      // var m=new moment.utc(r.Data_Ultimo_Ordine__c,'YYYY/MM/DD');
      // r.gg_ultimo_ordine=(m.valueOf()-moment())/60/60/24/1000;

      if (this.nomescalacolori=='Differenza AC-AP') {
        var c;
        if (r.Fatturato_delta_AC_AP_YTD__c && r.Fatturato_delta_AC_AP_YTD__c<-30000) c=this.scaladelta[0];
        if (r.Fatturato_delta_AC_AP_YTD__c<-10000) c=this.scaladelta[1];
        if (r.Fatturato_delta_AC_AP_YTD__c<-1000) c=this.scaladelta[2];
        if (r.Fatturato_delta_AC_AP_YTD__c>1000) c=this.scaladelta[3];
        if (r.Fatturato_delta_AC_AP_YTD__c>10000) c=this.scaladelta[4];
        if (r.Fatturato_delta_AC_AP_YTD__c>30000) c=this.scaladelta[5];

        if (c) {
          r.colore_categoria=c.color;
          r.nomeicona=c.nomeicona;
          r.attributo='€'+r.Fatturato_delta_AC_AP_YTD__c;
          r.targetName=r.Name+' '+r.attributo;
        } else {
          r.colore_categoria='#b6b0a8';
          r.nomeicona='nullo';
          r.attributo='N/A';
          r.targetName=r.Name+' '+r.attributo;
        }        
      }

      if (this.nomescalacolori=='Fatturato AC') {
        var c;
        if (r.Fatturato_AC__c<=1000) c=this.scalafatturato[0];
        if (r.Fatturato_AC__c>1000) c=this.scalafatturato[1];
        if (r.Fatturato_AC__c>10000) c=this.scalafatturato[2];
        if (r.Fatturato_AC__c>20000) c=this.scalafatturato[3];
        if (r.Fatturato_AC__c>30000) c=this.scalafatturato[4];
        if (r.Fatturato_AC__c>=50000) c=this.scalafatturato[5];

        if (c) {
          r.colore_categoria=c.color;
          r.nomeicona=c.nomeicona;
          r.attributo='€'+r.Fatturato_AC__c;
          r.targetName=r.Name+' '+r.attributo;
        } else {
          r.colore_categoria='#b6b0a8';
          r.nomeicona='nullo';
          r.attributo='N/A';
          r.targetName=r.Name+' '+r.attributo;
        }        
      }

      if (this.nomescalacolori=='Ultimo Ordine') {
        var c;
        if (r.GG_Ultimo_Ordine__c && r.GG_Ultimo_Ordine__c<=7) c=this.scalaordine[5];
        if (r.GG_Ultimo_Ordine__c>7) c=this.scalaordine[4];
        if (r.GG_Ultimo_Ordine__c>30) c=this.scalaordine[3];
        if (r.GG_Ultimo_Ordine__c>60) c=this.scalaordine[2];
        if (r.GG_Ultimo_Ordine__c>90) c=this.scalaordine[1];
        if (r.GG_Ultimo_Ordine__c>180) c=this.scalaordine[0];

        if (c) {
          r.colore_categoria=c.color;
          r.nomeicona=c.nomeicona;
          r.attributo=r.GG_Ultimo_Ordine__c;
          r.targetName=r.Name+' '+r.attributo;
        } else {
          r.colore_categoria='#b6b0a8';
          r.nomeicona='nullo';
          r.attributo='N/A';
          r.targetName=r.Name+' '+r.attributo;
        }        
      }

      if (this.nomescalacolori=='Categorie') {
        if (this.mapcategorie.has(r.Categoria_Vendita__c)) {
            var ic=this.mapcategorie.get(r.Categoria_Vendita__c);
            var c=this.menucategorie[ic];

            r.disabled=false;
            if (c.checked) {
              r.colore_categoria=c.color;
              r.nomeicona=c.nomeicona;
              r.attributo=r.Categoria_Vendita__c;
              r.targetName=r.Name+' '+r.attributo;
            } else {
              r.disabled=true;
            }
        } else {
          r.colore_categoria='#b6b0a8';
          r.nomeicona='nullo';
          r.attributo='Altro';
          r.targetName=r.Name+' '+r.attributo;
        }        
      }

    },
    getAllRecords: function() {
      var self = this;
      return new Promise(async function(resolve, reject) {
        self.mapids=new Map();
        self.maplatitudes=new Map();

        if (self.accounttype == '') {
          console.log('resolve: accounttype blank');
          self.records.splice(0, self.records.length);
          resolve(self.records);
        } else {

          self.placequeryresult.forEach(function(r) {
              self.mapids.set(r.place_id,r);
          });

          var map = self.$store.getters.map;
          var b = map.getBounds();
          if (!b) return;

          var ne = b.getNorthEast();
          var nelat = ne.lat();
          var nelng = ne.lng();
          var sw = b.getSouthWest();
          var swlat = sw.lat();
          var swlng = sw.lng();

          self.records.splice(0, self.records.length);
          self.leads.splice(0, self.leads.length);

          for(var [i, m] of self.menutipi.entries()) {
            console.log('--> '+m.label)

            if(!self.accounttype[i].checked) continue

            if(m.isAccount) {
              var records = await self.getMapRecordsAccount(nelat, nelng, swlat, swlng, m.filters)
              console.log('getMapRecordsAccount');

              records.forEach(function(r) {
                r.Key = m.name

                if(m.name == '0') {
                  self.mapids.set(r.Id,r);
                  self.addLat(r.Latitude, r);
                  if (r.Places_id__c) self.mapplaces.set(r.Places_id__c, r);

                  self.leads.push(r)
                  
                } else {

                  self.records.push(r)

                  self.mapids.set(r.Id,r);
                  r.Latitude=r.BillingLatitude;
                  r.Longitude=r.BillingLongitude;
                  self.addLat(r.Latitude, r);
                  if(m.name == '1' || m.name == '5') self.calcolaColori(r);
                }
              });
              console.log('found ' + self.records.length);

            }

            if(m.isLead) {
              var records = await self.getMapRecordsFromLead(nelat,nelng,swlat,swlng, m.filters)

              records.forEach(function(r) {
                r.Key = m.name
                self.records.push(r)

                self.mapids.set(r.Id,r);
                self.addLat(r.Latitude, r);
                if (r.Places_id__c) self.mapplaces.set(r.Places_id__c, r);
              });
              console.log('this.records', self.records)
            }
          }
          resolve()

        }
      }).catch( err => { throw err })
    },
    getMapRecordsAccount(nelat, nelng, swlat, swlng, filters) {
      var self = this;
      return new Promise(function(resolve, reject) {
        console.log("getMapRecordsAccount");

        var soql = "SELECT";
        soql += " Id, name, Categoria_Vendita__c, Places_id__c, RecordType.DeveloperName, Codice_2019__c, BillingLatitude, BillingLongitude, BillingGeocodeAccuracy, BillingStreet, BillingCity, BillingState, BillingCountry";
        soql += " FROM account"
        soql += " WHERE BillingLatitude>" + swlat + " and BillingLatitude<" + nelat;
        soql += " and  BillingLongitude>" + swlng + " and BillingLongitude<" + nelng;

        if (self.$store.getters.zona<'990') soql+= " AND Zona_1__c='"+self.$store.getters.zona+"'";

        if(filters && filters.length > 0) {
          for(var f of filters) {
            soql += " AND "+f
          }
        }

        console.log(soql);
        apiclient.query(self.$store.getters.connection, soql).then(function(data) {
          console.log("getMapRecordsAccount records:" + data.length);
          resolve(data);
        }).catch(function(err) {
          console.log(err);
          reject(err);
        });
      });
    },
    getMapRecordsFromLead(nelat, nelng, swlat, swlng, filters) {
      var self = this;
      return new Promise(function(resolve, reject) {
        console.log("getMapRecordsFromLead");

        var soql = "SELECT";
        soql += " Id, Name, Street, PostalCode, City, State, Nota_su_Lead_Competitor__c, Account_simile_o_vicino__c, Latitude, Longitude, LeadSource";
        soql += " FROM lead"
        soql += " WHERE Latitude>" + swlat + " and Latitude<" + nelat;
        soql += " and Longitude>" + swlng + " and Longitude<" + nelng;
        
        if (self.$store.getters.zona<'990') soql+= " AND Zona_1__c='"+self.$store.getters.zona+"'";

        if(filters && filters.length > 0) {
          for(var f of filters) {
            soql += " AND "+f
          }
        }

        console.log(soql);
        apiclient.query(self.$store.getters.connection, soql)
        .then(function(data) {
          console.log("getMapRecordsFromLead records:" + data.length);
          resolve(data);
        }).catch(function(err) {
          console.error(err);
          reject(err);
        });
      });
    },
    initMap: function() {
      console.log("initMap");
      var pos = this.$store.getters.position;
      console.log("initial position");
      console.log(pos);
      // eslint-disable-next-line no-undef
      var map = new google.maps.Map(document.getElementById("themap"), {
        /*
        center: {
          lat: parseFloat(pos.lat),
          lng: parseFloat(pos.lng)
        },
        */
        zoom: 12,
        mapId: 'AIzaSyCdw3TXE8PvSNVEtppvTHyA3P49kGvz77A'
      });
      this.$store.commit("SET_MAP", map);
    },
  },
};
</script>

<style scoped>
.nospaxce {
    padding: 0rem;
}


#themap {
  height: 100%;
}
.small {
  font-size: 10px;
}


.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 40px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  position: absolute;
  z-index: 1;

  bottom: 100%;
  left: 50%;
  margin-left: -20px;

}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.leadhide {
    background-color: red;
    border-color: red;
}
</style>
